import { GET_INVOICES } from "constants/invoices";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_INVOICES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
